import { render, staticRenderFns } from "./ehc-user-avatar.vue?vue&type=template&id=69baea83&scoped=true"
import script from "./ehc-user-avatar.vue?vue&type=script&lang=js"
export * from "./ehc-user-avatar.vue?vue&type=script&lang=js"
import style0 from "./ehc-user-avatar.vue?vue&type=style&index=0&id=69baea83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69baea83",
  null
  
)

export default component.exports